import React from 'react';
import { LinkData } from '../types';

interface Props {
  config: Record<string, any>;
  links: LinkData[];
}

export const ImageCarousel: React.FC<Props> = ({ config, links }) => {
  // Use correct field names from types.ts
  const {
    moduleHeading = 'Featured Products',
    visibleSlides = '4',
    cardStyle = 'image-title',
    showArrows = true,
    showDots = false,
    gap = 'md',
  } = config;

  const numVisible = parseInt(visibleSlides as string, 10) || 4;

  // Get gap value in pixels
  const getGapValue = () => {
    switch (gap) {
      case 'none':
        return '0px';
      case 'sm':
        return '8px';
      case 'lg':
        return '20px';
      default:
        return '12px'; // md
    }
  };

  return (
    <div style={{ padding: '20px', borderRadius: '8px', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      <h2 style={{ color: '#1e3a5f', margin: '0 0 16px', fontSize: '1.25rem', fontWeight: 600 }}>{moduleHeading}</h2>
      <div style={{ position: 'relative' }}>
        {showArrows && (
          <button
            style={{
              position: 'absolute',
              left: '-12px',
              top: '50%',
              transform: 'translateY(-50%)',
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              border: 'none',
              background: 'white',
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
              cursor: 'pointer',
              zIndex: 1,
            }}
          >
            ←
          </button>
        )}
        <div style={{ display: 'flex', gap: getGapValue(), overflow: 'hidden' }}>
          {links.slice(0, numVisible).map((link, i) => (
            <a
              key={i}
              href={link.url}
              style={{
                flex: 1,
                minWidth: 0,
                background: 'white',
                borderRadius: '8px',
                boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                overflow: 'hidden',
                textDecoration: 'none',
                display: 'block',
              }}
            >
              <div
                style={{
                  height: '100px',
                  background: link.image
                    ? `url(${link.image}) center/cover`
                    : 'linear-gradient(135deg, #3ecf8e22, #14b8a644)',
                  overflow: 'hidden',
                }}
              >
                {link.image && (
                  <img
                    src={link.image}
                    alt={link.title || ''}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                )}
              </div>
              {cardStyle !== 'image-only' && (
                <div style={{ padding: '10px' }}>
                  <span
                    style={{
                      margin: 0,
                      fontSize: '0.85rem',
                      lineHeight: 1.3,
                      color: '#1e3a5f',
                      fontWeight: 500,
                      display: 'block',
                    }}
                  >
                    {(link.title || link.anchorText || link.url).substring(0, 50)}
                    {(link.title || '').length > 50 ? '...' : ''}
                  </span>
                </div>
              )}
            </a>
          ))}
        </div>
        {showArrows && (
          <button
            style={{
              position: 'absolute',
              right: '-12px',
              top: '50%',
              transform: 'translateY(-50%)',
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              border: 'none',
              background: 'white',
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
              cursor: 'pointer',
              zIndex: 1,
            }}
          >
            →
          </button>
        )}
      </div>
      {showDots && (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '6px', marginTop: '12px' }}>
          {[0, 1, 2].map((i) => (
            <span
              key={i}
              style={{ width: '8px', height: '8px', borderRadius: '50%', background: i === 0 ? '#2db77a' : '#ddd' }}
            />
          ))}
        </div>
      )}
    </div>
  );
};
